module.exports = __webpack_public_path__ + "static/media/towels-light-gray.75d1e2de.svg";